import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-napkin-drawings',
  templateUrl: './napkin-drawings.component.html',
  styleUrls: ['./napkin-drawings.component.css']
})
export class NapkinDrawingsComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'image', url: 'assets/projects/NapkinDrawings/1.jpeg', title: '1.jpeg' },
    { id: 2, type: 'image', url: 'assets/projects/NapkinDrawings/2.jpg', title: '2.jpg' },
    { id: 3, type: 'image', url: 'assets/projects/NapkinDrawings/3.jpeg', title: '3.jpeg' },
    { id: 4, type: 'image', url: 'assets/projects/NapkinDrawings/4.jpg', title: '4.jpg' },
    { id: 5, type: 'image', url: 'assets/projects/NapkinDrawings/5.jpg', title: '5.jpg' },
    { id: 6, type: 'image', url: 'assets/projects/NapkinDrawings/6.jpg', title: '6.jpg' },
    { id: 7, type: 'image', url: 'assets/projects/NapkinDrawings/7.jpg', title: '7.jpg' },
    { id: 8, type: 'video', url: 'assets/projects/NapkinDrawings/8.mp4', title: '8.mp4' },
    { id: 9, type: 'image', url: 'assets/projects/NapkinDrawings/9.jpg', title: '9.jpg' },
    { id: 10, type: 'image', url: 'assets/projects/NapkinDrawings/10.jpg', title: '10.jpg' },
    { id: 11, type: 'image', url: 'assets/projects/NapkinDrawings/11.jpg', title: '11.jpg' },
    { id: 12, type: 'image', url: 'assets/projects/NapkinDrawings/12.jpg', title: '12.jpg' },
    { id: 13, type: 'image', url: 'assets/projects/NapkinDrawings/13.jpg', title: '13.jpg' },
    { id: 14, type: 'image', url: 'assets/projects/NapkinDrawings/14.jpg', title: '14.jpg' },
    { id: 15, type: 'image', url: 'assets/projects/NapkinDrawings/15.jpg', title: '15.jpg' },
    { id: 16, type: 'image', url: 'assets/projects/NapkinDrawings/16.jpg', title: '16.jpg' },
    { id: 17, type: 'image', url: 'assets/projects/NapkinDrawings/17.jpg', title: '17.jpg' },
    { id: 18, type: 'image', url: 'assets/projects/NapkinDrawings/18.jpg', title: '18.jpg' },
    { id: 19, type: 'image', url: 'assets/projects/NapkinDrawings/19.jpg', title: '19.jpg' },
    { id: 20, type: 'image', url: 'assets/projects/NapkinDrawings/20.jpg', title: '20.jpg' },
    { id: 21, type: 'image', url: 'assets/projects/NapkinDrawings/21.jpg', title: '21.jpg' },
    { id: 22, type: 'image', url: 'assets/projects/NapkinDrawings/22.jpg', title: '22.jpg' },
    { id: 23, type: 'image', url: 'assets/projects/NapkinDrawings/23.jpg', title: '23.jpg' },
    { id: 24, type: 'image', url: 'assets/projects/NapkinDrawings/24.jpg', title: '24.jpg' },
    { id: 25, type: 'image', url: 'assets/projects/NapkinDrawings/25.jpg', title: '25.jpg' },
    { id: 26, type: 'image', url: 'assets/projects/NapkinDrawings/26.jpg', title: '26.jpg' },
    { id: 27, type: 'image', url: 'assets/projects/NapkinDrawings/27.jpg', title: '27.jpg' },
    { id: 28, type: 'image', url: 'assets/projects/NapkinDrawings/28.jpg', title: '28.jpg' }
  ]

  constructor() { }

  ngOnInit(): void {
  }

}
